import { validateResponse, checkResponseError } from "../lib/validateResponse";
import {
  VALIDATE_FORM_FIELD,
  VALIDATE_FORM_FIELD_SUCCESS,
  VALIDATE_FORM_FIELD_ERROR
} from "../lib/formsReducer";

export const LOGIN_START = "LOGIN_START";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";

export const LOGOUT_START = "LOGOUT_START";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_ERROR = "LOGOUT_ERROR";

export const REFRESH_TOKEN_START = "REFRESH_TOKEN_START";
export const REFRESH_TOKEN_SUCCESS = "REFRESH_TOKEN_SUCCESS";
export const REFRESH_TOKEN_ERROR = "REFRESH_TOKEN_ERROR";

export const CHECK_TOKEN_START = "CHECK_TOKEN_START";
export const CHECK_TOKEN_SUCCESS = "CHECK_TOKEN_SUCCESS";
export const CHECK_TOKEN_ERROR = "CHECK_TOKEN_ERROR";

// Validation
export const validateForm = {
  login: (validate, fields, oneField) =>
    validate(fields, oneField)
      .prop("email", "Adres email")
      .required()
      .email()
      .prop("password", "Hasło")
      .required()
      .prop("token", "Token")
      .range(4, 10)
      .getErrors().promise
};

// Requests
const postOAuthToken = (
  fetch,
  apiHost,
  clientId,
  clientSecret,
  fields,
  msg
) => {
  fields = fields.set("client_id", clientId);
  fields = fields.set("client_secret", clientSecret);
  fields = fields.set("username", fields.get("email"));
  fields = fields.set("grant_type", "password");
  fields = fields.set("scope", "*");

  return fetch(`${apiHost}/oauth2/token`, {
    body: JSON.stringify(fields),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    method: "post"
  }).then(response => {
    return validateResponse(
      response,
      {
        "2fa_token_invalid": {
          msg: msg.forms.login.errors.wrong2FAToken,
          field: "token"
        },
        user_not_active: {
          msg: msg.forms.login.errors.userNotActive,
          field: "all"
        },
        password_not_set: {
          msg: msg.forms.login.errors.passwordNotSet,
          field: "all"
        },
        email_invalid: [
          {
            msg: msg.forms.login.errors.wrongEmail,
            field: "email"
          }
        ],
        password_invalid: [
          {
            msg: msg.forms.login.errors.wrongPassword,
            field: "password"
          }
        ],
        client_credentials_invalid: [
          {
            msg: msg.forms.login.errors.wrongPasswordOrEmail,
            field: "email"
          },
          {
            msg: msg.forms.login.errors.wrongPasswordOrEmail,
            field: "password",
            show: false
          }
        ]
      },
      true
    );
  });
};

const putOAuthTokenInvalidate = (fetch, apiHost, accessToken, msg) => {
  return fetch(`${apiHost}/oauth2/token/invalidate`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`
    },
    method: "put"
  }).then(response => {
    return validateResponse(response, {});
  });
};

const postOAuthTokenRefresh = (
  fetch,
  apiHost,
  clientId,
  clientSecret,
  refreshToken,
  msg
) => {
  const fields = {
    client_id: clientId,
    client_secret: clientSecret,
    grant_type: "refresh_token",
    scope: "*",
    refresh_token: refreshToken
  };

  return fetch(`${apiHost}/oauth2/token`, {
    body: JSON.stringify(fields),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    method: "post"
  }).then(response => {
    return validateResponse(response, {}, true);
  });
};

const postOAuthTokenCheck = (fetch, apiHost, accessToken, msg) => {
  return fetch(`${apiHost}/oauth2/token/check`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`
    },
    method: "post"
  }).then(response => {
    return validateResponse(response, {}, true);
  });
};

// Actions
export function login(fields) {
  return ({ fetch, validate, config, msg }) => ({
    type: "LOGIN",
    payload: {
      promise: validateForm
        ["login"](validate, fields)
        .then(() =>
          postOAuthToken(
            fetch,
            config().apiHost,
            config().clientId,
            config().clientSecret,
            fields,
            msg().auth
          ))
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        }),
      data: { fetch, validate, config, msg, fields }
    }
  });
}

export function logout(msg) {
  return ({ fetch, validate, config, users }) => ({
    type: "LOGOUT",
    payload: {
      promise: putOAuthTokenInvalidate(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        msg
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      })
    }
  });
}

export function checkToken() {
  return ({ fetch, validate, config, users, msg }) => ({
    type: "CHECK_TOKEN",
    payload: {
      promise: postOAuthTokenCheck(
        fetch,
        config().apiHost,
        users().viewer && users().viewer.accessToken,
        msg().auth
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      })
    }
  });
}

export function refreshToken() {
  return ({ fetch, validate, config, msg, users }) => ({
    type: "REFRESH_TOKEN",
    payload: {
      promise: postOAuthTokenRefresh(
        fetch,
        config().apiHost,
        config().clientId,
        config().clientSecret,
        users().viewer && users().viewer.refreshToken,
        msg().auth
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      })
    }
  });
}

// Standard functions
export function validateFormFieldAuth(form, name, value) {
  const feature = "auth";
  let fields = {};
  fields[name] = value;
  return ({ fetch, validate, config, users }) => ({
    type: [`${VALIDATE_FORM_FIELD}_${feature.toUpperCase()}`],
    payload: {
      promise: validateForm[form](validate, fields, true).catch(err => {
        let error = checkResponseError(err);
        throw error;
      })
    }
  });
}



// WEBPACK FOOTER //
// ./src/common/auth/actions.js